import React from 'react';

const StarRating = ({ rating, setRating, readOnly = false, size = "w-5 h-5" }) => {
  // Map old size prop to button sizes
  const btnClass = size === 'w-4 h-4'
    ? 'w-5 h-5 text-[9px]'
    : size === 'w-7 h-7'
      ? 'w-7 h-7 text-xs'
      : 'w-6 h-6 text-[10px]';

  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
        <button
          key={n}
          type="button"
          disabled={readOnly}
          onClick={() => !readOnly && setRating(n)}
          className={`${readOnly ? 'cursor-default' : 'cursor-pointer hover:scale-110 transition-transform'} ${btnClass} rounded-full font-bold flex items-center justify-center ${n <= rating ? 'bg-amber-400 text-white' : 'bg-slate-100 text-slate-400'}`}
        >
          {n}
        </button>
      ))}
    </div>
  );
};

export default StarRating;
